export const ALL_GROUPS = 'ALL_GROUPS';
export const NO_GROUP = 'NO_GROUP';
